export const iconFontAwesomeCampingTentArrowsDown = (
	<i className="fa-solid fa-tent-arrows-down"></i>
);
